export function observeLazyIframes() {
  const frames = document.querySelectorAll('iframe[data-lbx-lazy-src]');
  if (!frames.length)
    return;

  const load = (frame) => {
    frame.src = frame.dataset.lbxLazySrc;
    frame.removeAttribute('data-lbx-lazy-src');
  };

  if (!('IntersectionObserver' in window)) {
    frames.forEach(load);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting)
        return;
      observer.unobserve(entry.target);
      load(entry.target);
    });
  }, { rootMargin: '300px 0px' });

  frames.forEach((frame) => observer.observe(frame));
}
